
const didVisit = (deliveries) => {
    const visits = { arrived: 0, pending: 0, delivered: 0, out_of_plan: 0, canceled: 0 };

    deliveries.forEach(delivery => {
        const key = delivery.status;
        visits[key] = visits[key] + 1;
    });

    return (visits.canceled + visits.delivered + visits.out_of_plan) > 0;
};

export default {
    didVisit: didVisit
}



// WEBPACK FOOTER //
// ./src/helpers/Visit.js